import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import client from 'api/apiClient';
import { getDefaultCompanyId } from 'utils/helpers';

interface typesOfWalletTransactionDetail {
    transactionDetail: any;
    loading: boolean;
    error: string | null;
}
const initialState: typesOfWalletTransactionDetail = {
    transactionDetail: {},
    loading: false,
    error: null,
};

export const fetchTransactionDetail = createAsyncThunk(
    'transactionDetail/fetchTransactionDetail',
    async ({ id }: { id: string }, { getState }) => {
        const state: any = getState();
        const defaultCompanyId = getDefaultCompanyId(state);
        if (!id) return;
        const response: any = await client.get(`/merchant/trxDetail/${id}`, {
            headers: {
                companyId: defaultCompanyId,
            },
        });
        return response?.trxHistory;
    }
);

const transactionDetailSlice = createSlice({
    name: 'transactionDetail',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchTransactionDetail.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchTransactionDetail.fulfilled, (state, action) => {
            state.loading = false;
            if (!action?.payload) return;
            state.transactionDetail = action?.payload || {};
        });
        builder.addCase(fetchTransactionDetail.rejected, (state) => {
            state.loading = false;
        });
    },
});

export default transactionDetailSlice.reducer;
